<gsp-checkbox
    [(value)]="value"
    [disabled]="!enabled"
    [helpText]="hintText"
    [hidden]="!visible"
    [id]="name"
    [label]="label"
    [title]="infoMessage"
></gsp-checkbox>
